import React from 'react';
import { Layout, Text, useTheme} from '@ui-kitten/components';
import { useQuery } from '@apollo/react-hooks';
import { Q_GET_ORGANIZATIONS } from '../../data/api/query/q_organizations';
import { AuthContext } from '../../App';
import { useScreenDimensions } from '../../utils/useScreenInfo';
import { OrgList } from '../../components/organizations/orgList';





export function OrganizationListScreen({ navigation }): React.ReactElement {
    const { pageSpacerHorizontal } = useScreenDimensions();
    const { user } = React.useContext(AuthContext);
    const MAIN_COLOR: string = useTheme()['color-primary-default'];
    const { loading, error, data } = useQuery(Q_GET_ORGANIZATIONS, {
        fetchPolicy: 'network-only'
    });


    if (loading) {
        return <Text>Loading...</Text>;
    };
    if (error)  {
        console.log('useQuery', error);
        return <Text>Error :(</Text>;
    };
    console.log('we have data, ', data)

      

    return (
        <Layout level='3' style={{ flex: 1 }}>
            <OrgList
                data={data}
                navigation={navigation}
                pageSpacerHorizontal={pageSpacerHorizontal}
                user_org_id={user ? user.org_id : undefined}
                highlightColor={MAIN_COLOR}
            />
        </Layout>
    );
}




